import React, { useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function EliminarRubro({
  registro = {},
  onClose = () => {},
  onDeleted = () => {},
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleDelete = async () => {
    setError("");
    setLoading(true);

    try {
      const id = registro.id;
      if (!id) throw new Error("ID de rubro no encontrado.");

      await appFetchJson(apiRoutes.rubros.delete(id), { method: "DELETE" });

      onDeleted();
      onClose();
    } catch (e) {
      let msg = "No se pudo eliminar el rubro.";
      if (e.status === 404) msg = "El rubro ya no existe.";
      else if (e.status === 409)
        msg =
          e.bodyText ||
          "No se puede eliminar porque está siendo utilizado por otros registros.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full">
      <div className="px-6 py-4 border-b">
        <h2 className="section-title">Eliminar Rubro</h2>
      </div>

      <div className="px-6 pt-4">
        <div className="mb-4 px-4 py-3 text-sm text-blue-600">
          ¿Está seguro que desea eliminar este rubro?
        </div>

        <div className="bg-gray-50 px-6 py-6 mb-2 space-y-2">
          <div>
            <span className="text-gray-500 mr-1">Código:</span>
            <span className="font-medium">{registro.codigo ?? "—"}</span>
          </div>

          <div>
            <span className="text-gray-500 mr-1">Nombre:</span>
            <span className="font-medium">{registro.nombre ?? "—"}</span>
          </div>
        </div>

        {error && (
          <div className="mt-4 px-4 py-2 bg-red-50 text-red-600 text-sm font-bold rounded">
            {error}
          </div>
        )}
      </div>

      <div className="px-6 py-4 border-t flex gap-2 modal-footer">
        <button className="btn-fil" onClick={handleDelete} disabled={loading}>
          {loading ? "Eliminando…" : "Eliminar"}
        </button>

        <button className="btn-fil" onClick={onClose}>
          Cancelar
        </button>
      </div>
    </div>
  );
}